import { all } from 'redux-saga/effects'
import watchGetList from './get-list'
import watchUpdateStatus from './update-status'
import watchUpdate from './update'
import watchCreate from './create'
import watchGetDetail from './detail'


export default function* sagas() {
    yield all([
        watchGetList(),
        watchUpdateStatus(),
        watchUpdate(),
        watchCreate(),
        watchGetDetail()
    ])
}
